export default {
  roles: [],
  users: [],
}
